import { useQuery } from "@tanstack/react-query";

import { billingQueriesStore } from "@/features/billing/api";
import { PAYMENT_METHOD_TYPE } from "@/shared/domains";
import { CardSkeleton } from "@/shared/ui";
import { CreditCard, EmptyPaymentMethod } from ".";

export const PaymentMethodCard = () => {
  const {
    data: paymentMethod,
    isLoading,
    isError,
  } = useQuery(billingQueriesStore.payments._ctx.method);

  if (isLoading) {
    return <CardSkeleton />;
  }

  if (
    !paymentMethod ||
    paymentMethod.type === PAYMENT_METHOD_TYPE.KLARNA ||
    isError
  ) {
    return <EmptyPaymentMethod />;
  }

  return (
    <CreditCard.Root>
      <CreditCard.Chip />
      <CreditCard.Content>
        <div className="flex grow flex-col justify-between gap-2 pt-12 pb-1 xl:pt-14">
          <CreditCard.Title className="text-2xl font-medium text-neutral-950">
            **** **** **** {paymentMethod.metadata.lastFourDigits}
          </CreditCard.Title>

          <CreditCard.Description className="text-xs text-neutral-800">
            {paymentMethod.metadata.expireDate}
          </CreditCard.Description>
        </div>
      </CreditCard.Content>

      <CreditCard.Background />
    </CreditCard.Root>
  );
};
